import { render, staticRenderFns } from "./orderAfterSale.vue?vue&type=template&id=a5823a32&scoped=true&"
import script from "./orderAfterSale.vue?vue&type=script&lang=js&"
export * from "./orderAfterSale.vue?vue&type=script&lang=js&"
import style0 from "./orderAfterSale.vue?vue&type=style&index=0&id=a5823a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5823a32",
  null
  
)

export default component.exports